export const initialValues = {
    company: null,
    station: null,
    unit: null,
    name: '',
    latitude: '',
    longitude: '',
    capacity: '',
    type: '',
    deviceId: '',
    uuidAws: ''
}

export const valuesRequired = (isEdit) => {
    return({
        company: { required: !isEdit ? true : false },  
        station: { required: !isEdit ? true : false },  
        unit: { required: !isEdit ? true : false },  
        name: { required: true },
        latitude: { required: true },
        longitude: { required: true },
        capacity: { required: true },
        type: { required: true },
        // deviceId: { required: true  },
        // uuidAws: { required: true  }
    })
}